import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import { supabase } from '../../lib/supabase.js';
import { uploadListingPhoto } from '../../lib/storageService.js';
import {
  checkCanScan,
  consumeScan,
  analyzeImage,
  verifyIsDiskCover,
  iaScanErrorMessage,
  aiScanQualifiesForBilling,
  iaScanNoBillingMessage,
  countAiScanFilledFields,
} from '../../lib/aiScansService.js';
import { compressImageForAiScan } from '../../lib/storageService.js';
import { AI_SCAN_COST, GROOVES_PHONE_GATE_USER_MESSAGE } from '../constants/groovesEconomy.js';
import { Colors as C } from '../../constants/Colors.js';
import WebTopBar from '../components/WebTopBar.js';
import Icon from '../components/Icon.js';
import { DCard, BtnGold, BtnGhost, FieldInput } from '../components/MarketplaceAtoms.js';
import { GENEROS_TREE } from '../../constants/musicConstants.js';
import {
  aplicarGeneroDesdeIA,
  applyPublicarFieldsFromAi,
  inpBase,
  TipoPublicacionRow,
  YesNoRow,
  EstadoBloque,
  FORMATO_OPTS,
  GENEROS_PRINCIPALES,
} from '../publicarFormShared.js';
import { moderateText } from '../../lib/moderationService.js';
import { buildProfileLocationSummary } from '../../lib/profileLocationPublic.js';
import UbicacionSelector from '../components/UbicacionSelector.jsx';
import { geocodeListingUbicacion } from '../../lib/geocodingService.js';
import {
  fetchSellerListingRowForEdit,
  updateSellerListing,
} from '../../lib/listingsService.js';
import {
  buildPublicarStateFromListing,
  canSellerEditListing,
} from '../listingPublicarHydrate.js';
import PublicarPartnerCoverage from '../components/PublicarPartnerCoverage.js';
import {
  fetchListingPartnerCoverage,
  saveListingPartnerCoverage,
} from '../../lib/listingPartnerLogisticsService.js';
import {
  LISTING_SHIPPING_OPTIONS,
  shippingFlagsFromIndices,
} from '../constants/listingShipping.js';
import {
  sellerModesFromListingRow,
  sellerModesToArray,
} from '../constants/partnerLogistics.js';

/** Evita que la UI quede bloqueada si la petición a Supabase no resuelve (red, clave, etc.). */
const LISTING_INSERT_TIMEOUT_MS = 28000;

function promiseWithTimeout(promise, ms, timeoutMessage) {
  return new Promise((resolve, reject) => {
    const t = setTimeout(() => reject(new Error(timeoutMessage)), ms);
    promise
      .then(res => {
        clearTimeout(t);
        resolve(res);
      })
      .catch(err => {
        clearTimeout(t);
        reject(err);
      });
  });
}

const PARTNER_SHIPPING_IDX = [1, 2];

export default function PagePublicar({
  onBack,
  onNavigate,
  user,
  draftFromColeccion = null,
  listingToEdit = null,
  returnTo = null,
  partnerLogisticsEnabled = false,
}) {
  const [analyzing, setAnalyzing] = useState(false);
  const [done, setDone] = useState(false);
  const [envios, setEnvios] = useState([3]);
  const [modesPickup, setModesPickup] = useState({ physical: true, shipping: false });
  const [modesStore, setModesStore] = useState({ physical: true, shipping: false });
  const [coveragePickupIds, setCoveragePickupIds] = useState([]);
  const [coverageStoreIds, setCoverageStoreIds] = useState([]);
  const [locSel, setLocSel] = useState(0);
  /** Ubicación INE España si `Personalizada`. */
  const [pubProvincia, setPubProvincia] = useState('');
  const [pubMunicipio, setPubMunicipio] = useState('');

  const [esConjunto, setEsConjunto] = useState(false);
  const [artista, setArtista] = useState('');
  const [titulo, setTitulo] = useState('');
  const [anio, setAnio] = useState('');

  const [esEdicionEspecial, setEsEdicionEspecial] = useState(false);
  const [edicionNombre, setEdicionNombre] = useState('');
  const [edicionCatalogo, setEdicionCatalogo] = useState('');
  const [edicionContenido, setEdicionContenido] = useState('');
  const [edicionNumerada, setEdicionNumerada] = useState(false);
  const [edicionNumeroEjemplar, setEdicionNumeroEjemplar] = useState('');

  const [conjuntoTitulo, setConjuntoTitulo] = useState('');
  const [conjuntoNumDiscos, setConjuntoNumDiscos] = useState(2);
  const [conjuntoDescripcion, setConjuntoDescripcion] = useState('');

  const [estado, setEstado] = useState('');
  const [sello, setSello] = useState('');
  const [pais, setPais] = useState('');
  const [formato, setFormato] = useState("Vinilo 12\"");
  /** Clave de género principal (`GENEROS_TREE`). */
  const [genero, setGenero] = useState('');
  /** Subgénero libre o elegido del datalist (búsqueda fina en marketplace). */
  const [generoSub, setGeneroSub] = useState('');
  const [precio, setPrecio] = useState('');
  const [obs, setObs] = useState('');

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitOk, setSubmitOk] = useState(false);

  const [profileLoc, setProfileLoc] = useState({ location: null, pais: null, ciudad: null, localidad: null });

  const [modo, setModo] = useState(null);
  const [groovesDisponibles, setGroovesDisponibles] = useState(null);
  const [iaGateReason, setIaGateReason] = useState(null);
  const [iaAnalysisError, setIaAnalysisError] = useState(null);
  const [iaScanNote, setIaScanNote] = useState(null);
  const [puedeUsarIA, setPuedeUsarIA] = useState(false);
  /** Tres fotos: [0] portada principal, [1] cara disco, [2] otros */
  const [fotosFiles, setFotosFiles] = useState([null, null, null]);
  const [fotosPreviews, setFotosPreviews] = useState([null, null, null]);
  const fotoInputRef0 = useRef(null);
  const fotoInputRef1 = useRef(null);
  const fotoInputRef2 = useRef(null);
  const fotosInputRefs = useMemo(() => [fotoInputRef0, fotoInputRef1, fotoInputRef2], []);
  const coleccionDraftAppliedRef = useRef(null);
  const listingEditAppliedRef = useRef(null);
  const [editListingId, setEditListingId] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [editLoadError, setEditLoadError] = useState(null);
  const [editIsAuction, setEditIsAuction] = useState(false);
  const [editAuctionBidCount, setEditAuctionBidCount] = useState(0);
  const [editListingStatus, setEditListingStatus] = useState('active');
  const [camposInciertos, setCamposInciertos] = useState([]);

  const isEditMode = !!editListingId;

  useEffect(() => {
    if (!user?.id) return;
    supabase
      .from('profiles')
      .select('location, pais, ciudad, localidad')
      .eq('id', user.id)
      .single()
      .then(({ data }) => {
        if (data)
          setProfileLoc({
            location: data.location ?? null,
            pais: data.pais ?? null,
            ciudad: data.ciudad ?? null,
            localidad: data.localidad ?? null,
          });
      });
  }, [user?.id]);

  useEffect(() => {
    if (!user?.id) return;
    checkCanScan(user.id).then(({ canScan, grooves, reason }) => {
      setPuedeUsarIA(canScan);
      setGroovesDisponibles(grooves);
      setIaGateReason(reason || null);
    });
  }, [user?.id]);

  useEffect(() => {
    if (!submitting && !submitError && !submitOk) return;
    const el = document.getElementById('publicar-publicacion-feedback');
    el?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [submitting, submitError, submitOk]);

  /** Entrada desde perfil → colección: rellenar formulario manual y fotos por URL ya subidas. */
  /** Cargar anuncio existente para editar (desde Mis ventas / perfil). */
  useEffect(() => {
    const targetId = listingToEdit?.id ?? listingToEdit?.listingId ?? null;
    if (!targetId || !user?.id) {
      listingEditAppliedRef.current = null;
      setEditListingId(null);
      setEditLoadError(null);
      setEditLoading(false);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      setEditLoading(true);
      setEditLoadError(null);

      try {
        const { data: row, error } = await fetchSellerListingRowForEdit(user.id, targetId);
        if (cancelled) return;

        if (error || !row) {
          setEditLoadError(error || 'No se pudo cargar el anuncio.');
          return;
        }

        if (!canSellerEditListing(row)) {
          setEditLoadError('Este anuncio ya no se puede editar (vendido o retirado).');
          return;
        }

        let bidCount = 0;
        if (row.is_auction) {
          const { count, error: bidsErr } = await supabase
            .from('bids')
            .select('id', { count: 'exact', head: true })
            .eq('listing_id', targetId);
          if (bidsErr) console.warn('[PagePublicar] bids count:', bidsErr.message);
          bidCount = count ?? 0;
        }

        if (cancelled) return;

        const hydrated = buildPublicarStateFromListing(row);
        if (!hydrated) {
          setEditLoadError('No se pudieron cargar los datos del anuncio.');
          return;
        }

        listingEditAppliedRef.current = targetId;
        setEditListingId(targetId);
        setEditIsAuction(!!row.is_auction);
        setEditAuctionBidCount(bidCount);
        setEditListingStatus(String(row.status || 'active'));
        setModo(hydrated.modo);
        setDone(hydrated.done);
        setEsConjunto(hydrated.esConjunto);
        setArtista(hydrated.artista);
        setTitulo(hydrated.titulo);
        setAnio(hydrated.anio);
        setEsEdicionEspecial(hydrated.esEdicionEspecial);
        setEdicionNombre(hydrated.edicionNombre);
        setEdicionCatalogo(hydrated.edicionCatalogo);
        setEdicionContenido(hydrated.edicionContenido);
        setEdicionNumerada(hydrated.edicionNumerada);
        setEdicionNumeroEjemplar(hydrated.edicionNumeroEjemplar);
        setConjuntoTitulo(hydrated.conjuntoTitulo);
        setConjuntoNumDiscos(hydrated.conjuntoNumDiscos);
        setConjuntoDescripcion(hydrated.conjuntoDescripcion);
        setEstado(hydrated.estado);
        setSello(hydrated.sello);
        setPais(hydrated.pais);
        setFormato(hydrated.formato);
        setGenero(hydrated.genero);
        setGeneroSub(hydrated.generoSub);
        setPrecio(hydrated.precio);
        setObs(hydrated.obs);
        setEnvios(hydrated.envios);
        setLocSel(hydrated.locSel);
        setPubProvincia(hydrated.pubProvincia);
        setPubMunicipio(hydrated.pubMunicipio);
        setFotosFiles(hydrated.fotosFiles);
        setFotosPreviews(hydrated.fotosPreviews);
        setModesPickup(sellerModesFromListingRow(row, 'pickup'));
        setModesStore(sellerModesFromListingRow(row, 'store'));
        const { coverage } = await fetchListingPartnerCoverage(targetId);
        if (!cancelled) {
          setCoveragePickupIds(
            coverage.filter(c => c.coverage_role === 'pickup').map(c => c.partner_id)
          );
          setCoverageStoreIds(
            coverage.filter(c => c.coverage_role === 'store').map(c => c.partner_id)
          );
        }
        setCamposInciertos([]);
        setSubmitError(null);
        setSubmitOk(false);
      } catch (e) {
        if (!cancelled) {
          console.error('[PagePublicar] load edit listing', e);
          setEditLoadError(e?.message || 'Error al cargar el anuncio.');
        }
      } finally {
        if (!cancelled) setEditLoading(false);
      }
    })();

    return () => {
      cancelled = true;
      listingEditAppliedRef.current = null;
    };
  }, [listingToEdit, user?.id]);

  useEffect(() => {
    if (!draftFromColeccion?.id) {
      coleccionDraftAppliedRef.current = null;
      return;
    }
    if (coleccionDraftAppliedRef.current === draftFromColeccion.id) return;
    coleccionDraftAppliedRef.current = draftFromColeccion.id;

    const row = draftFromColeccion;
    setModo('manual');
    setDone(true);
    setAnalyzing(false);
    setEsConjunto(!!row.es_conjunto);
    if (row.es_conjunto) {
      setConjuntoTitulo(row.conjunto_titulo?.trim() || '');
      setConjuntoNumDiscos(Number(row.conjunto_num_discos) > 0 ? Number(row.conjunto_num_discos) : 2);
      setConjuntoDescripcion(row.conjunto_descripcion?.trim() || '');
      setArtista('');
      setTitulo('');
      setAnio('');
    } else {
      setArtista(row.artist?.trim() || '');
      setTitulo(row.title?.trim() || '');
      setAnio(row.release_year != null && row.release_year !== '' ? String(row.release_year) : '');
      setConjuntoTitulo('');
      setConjuntoDescripcion('');
      setConjuntoNumDiscos(2);
    }
    setEsEdicionEspecial(!!row.es_edicion_especial);
    setEdicionNombre(row.edicion_nombre?.trim() || '');
    setEdicionCatalogo(row.edicion_catalogo?.trim() || '');
    setEdicionContenido(row.edicion_contenido?.trim() || '');
    setEdicionNumerada(!!row.edicion_numerada);
    setEdicionNumeroEjemplar(row.edicion_numero_ejemplar?.trim() || '');
    setEstado(row.condition_code?.trim() || '');
    setSello(row.label_name?.trim() || '');
    setPais(row.country?.trim() || '');
    const fmt = row.format?.trim();
    setFormato(fmt && FORMATO_OPTS.includes(fmt) ? fmt : 'Vinilo 12"');
    aplicarGeneroDesdeIA(row.genre, setGenero, setGeneroSub);
    setObs([row.description, row.notes].filter(Boolean).join('\n\n').trim());
    setPrecio('');
    setFotosFiles([null, null, null]);
    setFotosPreviews([
      row.cover_url?.trim() || null,
      row.photo_url_2?.trim() || null,
      row.photo_url_3?.trim() || null,
    ]);
    setCamposInciertos([]);
    setSubmitError(null);
    setSubmitOk(false);
    fotosInputRefs.forEach(r => {
      if (r?.current) r.current.value = '';
    });
  }, [draftFromColeccion, fotosInputRefs]);

  const visibleShippingOptions = useMemo(
    () =>
      partnerLogisticsEnabled
        ? LISTING_SHIPPING_OPTIONS
        : LISTING_SHIPPING_OPTIONS.filter(o => !PARTNER_SHIPPING_IDX.includes(o.idx)),
    [partnerLogisticsEnabled]
  );

  useEffect(() => {
    if (partnerLogisticsEnabled) return;
    setEnvios(prev => {
      const next = prev.filter(i => !PARTNER_SHIPPING_IDX.includes(i));
      return next.length ? next : [3];
    });
    setCoveragePickupIds([]);
    setCoverageStoreIds([]);
  }, [partnerLogisticsEnabled]);

  const toggleEnvio = i => {
    if (!partnerLogisticsEnabled && PARTNER_SHIPPING_IDX.includes(i)) return;
    setEnvios(p => (p.includes(i) ? p.filter(x => x !== i) : [...p, i]));
  };

  const toggleCoveragePickup = useCallback(id => {
    setCoveragePickupIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  }, []);

  const toggleCoverageStore = useCallback(id => {
    setCoverageStoreIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  }, []);

  const setTipoConjunto = useCallback(next => {
    if (next) {
      setEsConjunto(true);
      setArtista('');
      setTitulo('');
      setAnio('');
      setEsEdicionEspecial(false);
      setEdicionNombre('');
      setEdicionCatalogo('');
      setEdicionContenido('');
      setEdicionNumerada(false);
      setEdicionNumeroEjemplar('');
    } else {
      setEsConjunto(false);
      setConjuntoTitulo('');
      setConjuntoDescripcion('');
      setConjuntoNumDiscos(2);
      setArtista('');
      setTitulo('');
      setAnio('');
    }
  }, []);

  const resetFormularioPublicacion = useCallback(() => {
    setEsConjunto(false);
    setArtista('');
    setTitulo('');
    setAnio('');
    setConjuntoTitulo('');
    setConjuntoDescripcion('');
    setConjuntoNumDiscos(2);
    setEsEdicionEspecial(false);
    setEdicionNombre('');
    setEdicionCatalogo('');
    setEdicionContenido('');
    setEdicionNumerada(false);
    setEdicionNumeroEjemplar('');
    setEstado('');
    setSello('');
    setPais('');
    setFormato('Vinilo 12"');
    setGenero('');
    setGeneroSub('');
    setPrecio('');
    setObs('');
    setEnvios([3]);
    setLocSel(0);
    setFotosFiles([null, null, null]);
    setFotosPreviews([null, null, null]);
    setCamposInciertos([]);
    setSubmitError(null);
    setSubmitOk(false);
  }, []);

  const setEdicionEspecialValue = useCallback(v => {
    setEsEdicionEspecial(v);
    if (!v) {
      setEdicionNombre('');
      setEdicionCatalogo('');
      setEdicionContenido('');
      setEdicionNumerada(false);
      setEdicionNumeroEjemplar('');
    }
  }, []);

  const toBase64File = useCallback(
    f =>
      new Promise((res, rej) => {
        const r = new FileReader();
        r.onload = () => {
          const s = String(r.result);
          const i = s.indexOf(',');
          res(i >= 0 ? s.slice(i + 1) : s);
        };
        r.onerror = () => rej(new Error('Error leyendo imagen'));
        r.readAsDataURL(f);
      }),
    []
  );

  const runIaAnalysisFromFile = useCallback(
    async file => {
      if (!file) return;
      setAnalyzing(true);
      setDone(false);
      setIaAnalysisError(null);
      setIaScanNote(null);
      setCamposInciertos([]);
      try {
        let fileForIa = file;
        try {
          fileForIa = await compressImageForAiScan(file);
        } catch {
          /* usar original */
        }
        const base64 = await toBase64File(fileForIa);
        const mediaType = fileForIa.type || 'image/jpeg';
        const { fields, lowConfidence, error } = await analyzeImage(base64, mediaType);

        if (error) {
          console.error('[PagePublicar] analyzeImage error:', error);
          setIaAnalysisError(iaScanErrorMessage(error));
          setDone(false);
          return;
        }

        applyPublicarFieldsFromAi(fields, {
          setArtista,
          setTitulo,
          setAnio,
          setSello,
          setPais,
          setFormato,
          setGenero,
          setGeneroSub,
        });

        setCamposInciertos(Array.isArray(lowConfidence) ? lowConfidence : []);

        const qualifiesForBilling = aiScanQualifiesForBilling(fields);
        const filledCount = countAiScanFilledFields(fields);
        if (user?.id && qualifiesForBilling) {
          const { ok, groovesRemaining, error: consumeErr } = await consumeScan(user.id);
          if (ok) {
            setGroovesDisponibles(groovesRemaining);
            setPuedeUsarIA(groovesRemaining >= AI_SCAN_COST);
            setIaGateReason(null);
            setIaScanNote(null);
          } else {
            setGroovesDisponibles(groovesRemaining);
            setPuedeUsarIA(false);
            if (consumeErr === 'phone_not_verified') setIaGateReason('phone_not_verified');
            else checkCanScan(user.id).then(({ canScan, grooves, reason }) => {
              setPuedeUsarIA(canScan);
              setGroovesDisponibles(grooves);
              setIaGateReason(reason || null);
            });
          }
        } else if (!qualifiesForBilling) {
          setIaScanNote(iaScanNoBillingMessage(fields));
        }

        setDone(filledCount > 0);
      } catch (err) {
        console.error('[PagePublicar] Error en análisis:', err);
        setIaAnalysisError(iaScanErrorMessage('network_error'));
        setDone(false);
      } finally {
        setAnalyzing(false);
      }
    },
    [user?.id, toBase64File]
  );

  const handleFotoSelect = useCallback(
    async (e, slotIndex) => {
      const file = e.target.files?.[0];
      if (!file) return;
      e.target.value = '';
      const reader = new FileReader();
      reader.onload = ev => {
        setFotosPreviews(prev => {
          const next = [...prev];
          next[slotIndex] = ev.target.result;
          return next;
        });
      };
      reader.readAsDataURL(file);
      setFotosFiles(prev => {
        const next = [...prev];
        next[slotIndex] = file;
        return next;
      });
      if (slotIndex === 0 && modo === 'ia') {
        await runIaAnalysisFromFile(file);
      }
    },
    [modo, runIaAnalysisFromFile]
  );

  const handleFotoClear = useCallback((slotIndex, e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    setFotosFiles(prev => {
      const next = [...prev];
      next[slotIndex] = null;
      return next;
    });
    setFotosPreviews(prev => {
      const next = [...prev];
      next[slotIndex] = null;
      return next;
    });
    const input = fotosInputRefs[slotIndex]?.current;
    if (input) input.value = '';
  }, [fotosInputRefs]);

  const handlePublicar = useCallback(async () => {
    setSubmitError(null);

    if (!user?.id) {
      setSubmitError('Debes iniciar sesión para publicar.');
      return;
    }
    if (!estado) {
      setSubmitError('Selecciona el estado del artículo.');
      return;
    }
    const skipPriceCheck = isEditMode && editIsAuction && editAuctionBidCount > 0;
    if (!skipPriceCheck && (!precio || isNaN(Number(precio)) || Number(precio) <= 0)) {
      setSubmitError('Introduce un precio válido.');
      return;
    }
    if (envios.length === 0) {
      setSubmitError('Selecciona al menos una opción de envío.');
      return;
    }
    if (partnerLogisticsEnabled && envios.includes(1) && (!modesPickup.physical && !modesPickup.shipping)) {
      setSubmitError('Marca al menos una forma de entrega al punto de recogida.');
      return;
    }
    if (partnerLogisticsEnabled && envios.includes(2) && (!modesStore.physical && !modesStore.shipping)) {
      setSubmitError('Marca al menos una forma de entrega al partner verificador.');
      return;
    }
    if (partnerLogisticsEnabled && envios.includes(1) && coveragePickupIds.length === 0) {
      setSubmitError('Marca al menos un punto de recogida DreamVinyl.');
      return;
    }
    if (partnerLogisticsEnabled && envios.includes(2) && coverageStoreIds.length === 0) {
      setSubmitError('Marca al menos una tienda verificadora.');
      return;
    }
    if (esConjunto && !conjuntoTitulo.trim()) {
      setSubmitError('Añade un título al conjunto.');
      return;
    }
    if (!esConjunto && !artista.trim()) {
      setSubmitError('El campo Artista es obligatorio.');
      return;
    }
    if (!esConjunto && !titulo.trim()) {
      setSubmitError('El campo Título es obligatorio.');
      return;
    }
    if (!genero.trim()) {
      setSubmitError('Selecciona un género principal.');
      return;
    }
    if (locSel === 1) {
      if (!String(pubProvincia).trim() || !String(pubMunicipio).trim()) {
        setSubmitError('En ubicación personalizada, elige provincia y municipio.');
        return;
      }
    }

    // Moderación heurística (cliente) para texto libre
    const titleToModerate = esConjunto ? conjuntoTitulo : titulo;
    const mt = moderateText(titleToModerate, 'listing_title');
    if (!mt.approved) {
      setSubmitError(`No se pudo publicar · ${mt.reason || 'Revisa el texto.'}`);
      return;
    }
    const descToModerate = esConjunto ? conjuntoDescripcion : obs;
    const md = moderateText(descToModerate, 'listing_description');
    if (!md.approved) {
      setSubmitError(`No se pudo publicar · ${md.reason || 'Revisa el texto.'}`);
      return;
    }

    const ubicacion =
      locSel === 0
        ? profileLoc
        : {
            location: buildProfileLocationSummary({
              pais: 'España',
              ciudad: String(pubProvincia).trim(),
              localidad: String(pubMunicipio).trim(),
            }),
            pais: 'España',
            ciudad: String(pubProvincia).trim(),
            localidad: String(pubMunicipio).trim(),
          };
    const genreFinal = (generoSub.trim() || genero.trim()) || null;

    let yearVal = null;
    if (anio != null && String(anio).trim() !== '') {
      const y = parseInt(String(anio).trim(), 10);
      if (Number.isFinite(y)) yearVal = y;
    }

    setSubmitting(true);
    try {
      const { lat: geoLat, lng: geoLng } = await geocodeListingUbicacion(ubicacion);

      let coverUrl = null;
      const uploadedPhotos = [];

      for (let i = 0; i < 3; i++) {
        const file = fotosFiles[i];
        const preview = fotosPreviews[i];
        const previewIsHttp =
          typeof preview === 'string' && /^https?:\/\//i.test(String(preview).trim());

        if (file) {
          if (i === 0) {
            const base64 = await toBase64File(file);
            const { isValid } = await verifyIsDiskCover(base64, file.type || 'image/jpeg');
            if (!isValid) {
              setSubmitError(
                'La imagen de ★ Portada no parece una carátula o artwork de álbum. Sustitúyela o quítala.'
              );
              return;
            }
            const { url, error: upErr } = await uploadListingPhoto(file, user.id, null);
            if (upErr) {
              setSubmitError('No se pudo subir la portada: ' + upErr);
              return;
            }
            if (url) {
              coverUrl = url;
              uploadedPhotos.push(url);
            }
          } else {
            const { url, error: upErr } = await uploadListingPhoto(file, user.id, null);
            if (upErr) {
              setSubmitError(`No se pudo subir la foto ${i + 1}: ` + upErr);
              return;
            }
            if (url) uploadedPhotos.push(url);
          }
        } else if (previewIsHttp) {
          const url = String(preview).trim();
          if (i === 0) {
            coverUrl = url;
            uploadedPhotos.push(url);
          } else {
            uploadedPhotos.push(url);
          }
        }
      }

      const titleVal = esConjunto ? (conjuntoTitulo.trim() || 'Sin título') : titulo.trim();
      const artistVal = esConjunto ? '(Varios)' : artista.trim();

      const row = {
        title: titleVal,
        artist: artistVal,
        year: yearVal,
        label: sello.trim() || null,
        country: pais.trim() || null,
        format: formato,
        genre: genreFinal,
        condition: estado,
        price: Number(precio),
        description: obs.trim() || null,
        photos: uploadedPhotos,
        cover_url: coverUrl ?? null,

        location: ubicacion.location,
        pais: ubicacion.pais,
        ciudad: ubicacion.ciudad,
        localidad: ubicacion.localidad,
        lat: geoLat ?? null,
        lng: geoLng ?? null,

        ...shippingFlagsFromIndices(envios),

        es_edicion_especial: esEdicionEspecial,
        edicion_nombre: esEdicionEspecial ? (edicionNombre.trim() || null) : null,
        edicion_catalogo: esEdicionEspecial ? (edicionCatalogo.trim() || null) : null,
        edicion_contenido: esEdicionEspecial ? (edicionContenido.trim() || null) : null,
        edicion_numerada: esEdicionEspecial ? edicionNumerada : false,
        edicion_numero_ejemplar:
          esEdicionEspecial && edicionNumerada ? (edicionNumeroEjemplar.trim() || null) : null,

        es_conjunto: esConjunto,
        conjunto_titulo: esConjunto ? (conjuntoTitulo.trim() || null) : null,
        conjunto_num_discos: esConjunto ? conjuntoNumDiscos : null,
        conjunto_descripcion: esConjunto ? (conjuntoDescripcion.trim() || null) : null,

      };

      if (!uploadedPhotos.length && !coverUrl) {
        setSubmitError('Añade al menos una foto del disco.');
        return;
      }

      if (isEditMode && editListingId) {
        if (editIsAuction && editAuctionBidCount > 0) {
          delete row.price;
        }
        const { error: upErr } = await updateSellerListing(user.id, editListingId, row);
        if (upErr) {
          console.error('[PagePublicar] update error:', upErr);
          setSubmitError('Error al guardar: ' + upErr);
          return;
        }
        const { error: covErr } = await saveListingPartnerCoverage({
          listingId: editListingId,
          storePartnerIds: envios.includes(2) ? coverageStoreIds : [],
          pickupPartnerIds: envios.includes(1) ? coveragePickupIds : [],
          modesStore: envios.includes(2) ? sellerModesToArray(modesStore) : null,
          modesPickup: envios.includes(1) ? sellerModesToArray(modesPickup) : null,
        });
        if (covErr) {
          setSubmitError('Anuncio guardado, pero falló la red de partners: ' + covErr);
          return;
        }
        setSubmitOk(true);
        setTimeout(() => {
          if (returnTo === 'misventas' && onNavigate) onNavigate('misventas');
          else if (returnTo === 'perfil' && onNavigate) onNavigate('perfil');
          else onBack();
        }, 2200);
        return;
      }

      const insertRow = {
        ...row,
        seller_id: user.id,
        status: 'active',
        is_seleccion_surco: false,
      };

      const insertReq = supabase.from('listings').insert(insertRow).select('id').single();
      const { data: inserted, error } = await promiseWithTimeout(
        insertReq,
        LISTING_INSERT_TIMEOUT_MS,
        'La solicitud tardó demasiado. Comprueba tu conexión a internet, la configuración y vuelve a intentarlo.'
      );
      if (error) {
        console.error('[PagePublicar] insert error:', error.message, error);
        setSubmitError('Error al publicar: ' + (error.message || 'Error desconocido'));
        return;
      }
      const newId = inserted?.id;
      if (newId && (envios.includes(1) || envios.includes(2))) {
        const { error: covErr } = await saveListingPartnerCoverage({
          listingId: newId,
          storePartnerIds: envios.includes(2) ? coverageStoreIds : [],
          pickupPartnerIds: envios.includes(1) ? coveragePickupIds : [],
          modesStore: envios.includes(2) ? sellerModesToArray(modesStore) : null,
          modesPickup: envios.includes(1) ? sellerModesToArray(modesPickup) : null,
        });
        if (covErr) {
          setSubmitError('Anuncio publicado, pero falló la red de partners: ' + covErr);
          return;
        }
      }
      setSubmitOk(true);
      setTimeout(() => onBack(), 3200);
    } catch (err) {
      console.error('[PagePublicar] insert exception:', err);
      setSubmitError(err?.message || 'Error inesperado al publicar. Inténtalo de nuevo.');
    } finally {
      setSubmitting(false);
    }
  }, [
    user,
    estado,
    precio,
    envios,
    coveragePickupIds,
    coverageStoreIds,
    modesPickup,
    modesStore,
    esConjunto,
    conjuntoTitulo,
    artista,
    titulo,
    anio,
    sello,
    pais,
    formato,
    genero,
    generoSub,
    obs,
    locSel,
    profileLoc,
    pubProvincia,
    pubMunicipio,
    esEdicionEspecial,
    edicionNombre,
    edicionCatalogo,
    edicionContenido,
    edicionNumerada,
    edicionNumeroEjemplar,
    conjuntoNumDiscos,
    conjuntoDescripcion,
    fotosFiles,
    fotosPreviews,
    toBase64File,
    onBack,
    onNavigate,
    isEditMode,
    editListingId,
    editIsAuction,
    editAuctionBidCount,
    returnTo,
    partnerLogisticsEnabled,
  ]);

  return (
    <div style={{ background: C.dark, minHeight: '100vh', color: '#fff' }}>
      <WebTopBar
        onBack={onBack}
        title={isEditMode ? 'Editar anuncio' : 'Publicar artículo'}
        mini
        dark
        user={user}
        onNavigate={onNavigate}
        onSignOut={onBack}
      />
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '24px 20px 60px' }}>
        {editLoading ? (
          <DCard style={{ padding: 16, marginBottom: 14 }}>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>Cargando anuncio…</div>
          </DCard>
        ) : null}
        {editLoadError ? (
          <DCard style={{ padding: 16, marginBottom: 14, borderColor: 'rgba(226,75,74,0.35)', background: 'rgba(226,75,74,0.08)' }}>
            <div style={{ fontSize: 13, color: '#E24B4A', marginBottom: 10 }}>{editLoadError}</div>
            <BtnGold type="button" onClick={onBack} style={{ padding: '8px 14px', fontSize: 11 }}>
              Volver
            </BtnGold>
          </DCard>
        ) : null}
        {isEditMode && !editLoading && !editLoadError ? (
          <DCard style={{ padding: 12, marginBottom: 14, background: 'rgba(55,138,221,0.08)', borderColor: 'rgba(55,138,221,0.25)' }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.85)', lineHeight: 1.5 }}>
              Estás editando un anuncio {editListingStatus === 'reserved' ? 'reservado' : 'activo'}.
              {editIsAuction && editAuctionBidCount > 0
                ? ' Ya hay pujas: no puedes cambiar el precio de salida.'
                : editIsAuction
                ? ' Es una subasta: el precio del formulario actúa como precio de salida.'
                : null}
            </div>
          </DCard>
        ) : null}
        {!isEditMode ? (
        <DCard style={{ padding: 14, marginBottom: 16, background: 'rgba(200,168,75,0.08)', borderColor: 'rgba(200,168,75,0.3)' }}>
          <div style={{ fontSize: 12, fontWeight: 500, color: C.gold, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
            <Icon name="info" size={14} color={C.gold} /> Cómo publicar un artículo
          </div>
          {[
            'Elige Manual (gratis, tú rellenas los datos) o Análisis IA (subes foto de carátula; cuesta Grooves y la IA propone campos).',
            'Si usas IA, revisa los campos resaltados en naranja cuando la confianza sea baja.',
            'Sube las imágenes del producto y la carátula. Cumplimenta los campos e indica género principal en el desplegable y el formato (vinilo, CD, casete…); el subgénero es opcional con sugerencias.',
            'Completa estado, precio, ubicación y al menos una opción de envío. Hasta 3 fotos (portada verificada con IA al publicar).',
            'Pulsa «Publicar anuncio» y espera: verás «Enviando…» mientras se guarda, luego un mensaje de éxito o de error.',
          ].map((s, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 4, alignItems: 'flex-start' }}>
              <div style={{ width: 16, height: 16, borderRadius: '50%', background: 'rgba(200,168,75,0.2)', color: C.gold, fontSize: 9, fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>{i + 1}</div>
              <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', lineHeight: 1.4 }}>{s}</span>
            </div>
          ))}
        </DCard>
        ) : null}

        {!modo && !isEditMode && (
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginBottom: 12, textAlign: 'center' }}>
              ¿Cómo quieres introducir los datos?
            </div>
            {iaGateReason === 'phone_not_verified' && user?.id ? (
              <DCard
                style={{
                  padding: 12,
                  marginBottom: 12,
                  background: 'rgba(239,159,39,0.08)',
                  borderColor: 'rgba(239,159,39,0.28)',
                }}>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.88)', lineHeight: 1.45, marginBottom: 10 }}>{GROOVES_PHONE_GATE_USER_MESSAGE}</div>
                <BtnGold type="button" onClick={() => onNavigate('ajustes', { initialSub: 'cuenta' })} style={{ padding: '8px 14px', fontSize: 11, borderRadius: 8 }}>
                  Ir a Ajustes
                </BtnGold>
              </DCard>
            ) : null}
            <div style={{ display: 'flex', gap: 10 }}>
              <div
                role="button"
                tabIndex={0}
                onClick={() => {
                  resetFormularioPublicacion();
                  setModo('manual');
                  setDone(true);
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    resetFormularioPublicacion();
                    setModo('manual');
                    setDone(true);
                  }
                }}
                style={{
                  flex: 1,
                  padding: '18px 12px',
                  borderRadius: 12,
                  cursor: 'pointer',
                  textAlign: 'center',
                  border: '0.5px solid rgba(255,255,255,0.15)',
                  background: 'rgba(255,255,255,0.03)',
                }}
              >
                <div style={{ fontSize: 22, marginBottom: 6 }}>💿</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#fff', marginBottom: 4 }}>Manual</div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', lineHeight: 1.4 }}>Rellenas tú los campos</div>
                <div style={{ fontSize: 10, color: '#5DCAA5', marginTop: 6 }}>Siempre gratis</div>
              </div>

              <div
                role="button"
                tabIndex={0}
                onClick={() => puedeUsarIA && setModo('ia')}
                onKeyDown={e => {
                  if ((e.key === 'Enter' || e.key === ' ') && puedeUsarIA) {
                    e.preventDefault();
                    setModo('ia');
                  }
                }}
                style={{
                  flex: 1,
                  padding: '18px 12px',
                  borderRadius: 12,
                  textAlign: 'center',
                  border: `0.5px solid ${puedeUsarIA ? 'rgba(200,168,75,0.4)' : 'rgba(255,255,255,0.08)'}`,
                  background: puedeUsarIA ? 'rgba(200,168,75,0.05)' : 'rgba(255,255,255,0.02)',
                  cursor: puedeUsarIA ? 'pointer' : 'not-allowed',
                  opacity: puedeUsarIA ? 1 : 0.6,
                }}
              >
                <div style={{ fontSize: 22, marginBottom: 6 }}>✨</div>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: puedeUsarIA ? C.gold : 'rgba(255,255,255,0.4)',
                    marginBottom: 4,
                  }}
                >
                  Análisis IA
                </div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', lineHeight: 1.4 }}>
                  Sube una foto y la IA rellena los campos
                </div>
                <div style={{ fontSize: 10, marginTop: 6, color: puedeUsarIA ? C.gold : '#E24B4A' }}>
                  {groovesDisponibles === null
                    ? 'Cargando...'
                    : iaGateReason === 'phone_not_verified'
                      ? GROOVES_PHONE_GATE_USER_MESSAGE
                      : puedeUsarIA
                        ? `${AI_SCAN_COST} Grooves · Tienes ${groovesDisponibles} ★`
                        : `Necesitas ${AI_SCAN_COST} Grooves · Tienes ${groovesDisponibles ?? 0} ★`}
                </div>
              </div>
            </div>
          </div>
        )}

        {modo === 'ia' && !done && !analyzing && (
          <div style={{ marginBottom: 16 }}>
            {iaGateReason === 'phone_not_verified' && user?.id ? (
              <DCard style={{ padding: 12, marginBottom: 10, background: 'rgba(239,159,39,0.08)', borderColor: 'rgba(239,159,39,0.28)' }}>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.88)', lineHeight: 1.45, marginBottom: 8 }}>{GROOVES_PHONE_GATE_USER_MESSAGE}</div>
                <BtnGold type="button" onClick={() => onNavigate('ajustes', { initialSub: 'cuenta' })} style={{ padding: '8px 12px', fontSize: 11, borderRadius: 8 }}>
                  Ir a Ajustes
                </BtnGold>
              </DCard>
            ) : null}
            <div style={{ fontSize: 11, color: C.gold, marginBottom: 10, textAlign: 'center', lineHeight: 1.45 }}>
              {AI_SCAN_COST} Grooves solo si la IA rellena título y artista (mín. 2 campos) · Tienes {groovesDisponibles ?? 0} ★ — sube la ★ Portada con el borde inferior visible (©, sello, país)
            </div>
            <div style={{ marginBottom: 6 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>Fotos · máximo 3 por publicación</div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
                {[
                  { label: '★ Portada', sublabel: 'Vinilo · CD · Casete · Blu-ray', index: 0 },
                  { label: 'Cara del disco', sublabel: 'Etiqueta o cara A/B', index: 1 },
                  { label: 'Otros', sublabel: 'Contraportada, extras...', index: 2 },
                ].map(({ label, sublabel, index }) => (
                  <div
                    key={index}
                    style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'stretch', gap: 6, minWidth: 0 }}
                  >
                    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                      <input
                        ref={fotosInputRefs[index]}
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={e => handleFotoSelect(e, index)}
                      />
                      <div
                        role="button"
                        tabIndex={0}
                        onClick={() => fotosInputRefs[index].current?.click()}
                        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && fotosInputRefs[index].current?.click()}
                        style={{
                          width: '100%',
                          aspectRatio: '1',
                          borderRadius: 8,
                          background: fotosPreviews[index] ? 'transparent' : index === 0 ? '#2d1b69' : 'rgba(255,255,255,0.03)',
                          border: fotosPreviews[index]
                            ? `1.5px solid ${index === 0 ? C.gold : 'rgba(255,255,255,0.2)'}`
                            : index === 0
                              ? '1.5px dashed rgba(200,168,75,0.4)'
                              : '1.5px dashed rgba(255,255,255,0.15)',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          minHeight: 70,
                        }}
                      >
                        {fotosPreviews[index] ? (
                          <img src={fotosPreviews[index]} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <span style={{ fontSize: index === 0 ? 22 : 18, color: 'rgba(255,255,255,0.25)' }}>
                            {index === 0 ? '🖼️' : '+'}
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: 9, color: index === 0 ? C.gold : 'rgba(255,255,255,0.35)', textAlign: 'center', lineHeight: 1.3 }}>
                        {label}
                      </div>
                      <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.25)', textAlign: 'center', lineHeight: 1.3 }}>
                        {sublabel}
                      </div>
                    </div>
                    {fotosPreviews[index] ? (
                      <button
                        type="button"
                        disabled={analyzing}
                        onClick={e => handleFotoClear(index, e)}
                        title={analyzing ? 'Espera a que termine el análisis' : 'Quitar esta foto'}
                        style={{
                          alignSelf: 'center',
                          flexShrink: 0,
                          padding: '6px 8px',
                          fontSize: 10,
                          fontWeight: 600,
                          lineHeight: 1.2,
                          borderRadius: 6,
                          border: '1px solid rgba(226, 75, 74, 0.45)',
                          background: analyzing ? 'rgba(255,255,255,0.04)' : 'rgba(226, 75, 74, 0.12)',
                          color: analyzing ? 'rgba(255,255,255,0.25)' : '#E89797',
                          cursor: analyzing ? 'not-allowed' : 'pointer',
                        }}
                      >
                        Quitar
                      </button>
                    ) : null}
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', textAlign: 'center', marginBottom: 8 }}>
                La portada (★) se verifica con IA · formatos: JPG, PNG, WEBP
              </div>
            </div>
          </div>
        )}

        {modo === 'ia' && iaAnalysisError && !analyzing && (
          <DCard style={{ padding: '12px 16px', marginBottom: 14, background: 'rgba(226,75,74,0.08)', borderColor: 'rgba(226,75,74,0.35)' }}>
            <div style={{ fontSize: 12, color: '#E89797', lineHeight: 1.45, marginBottom: 8 }}>{iaAnalysisError}</div>
            <BtnGhost
              type="button"
              onClick={() => {
                setIaAnalysisError(null);
                fotoInputRef0.current?.click();
              }}
              style={{ padding: '6px 10px', fontSize: 11 }}
            >
              Reintentar con otra foto (★ Portada)
            </BtnGhost>
          </DCard>
        )}

        {analyzing && (
          <DCard style={{ padding: '12px 16px', marginBottom: 14, background: 'rgba(83,74,183,0.1)', borderColor: 'rgba(83,74,183,0.3)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 16, height: 16, border: '2px solid rgba(83,74,183,0.3)', borderTopColor: '#7F77DD', borderRadius: '50%', animation: 'spin 0.8s linear infinite', flexShrink: 0 }}/>
              <span style={{ fontSize: 12, color: C.purpleL }}>Analizando imagen · Identificando disco...</span>
            </div>
          </DCard>
        )}

        {done && modo === 'ia' && (
          <DCard style={{ padding: '10px 14px', marginBottom: 14, background: 'rgba(83,74,183,0.08)', borderColor: 'rgba(83,74,183,0.25)' }}>
            <div style={{ fontSize: 11, color: C.purpleL, fontWeight: 500, marginBottom: 2 }}>
              IA detectó:{' '}
              {titulo || artista
                ? `${titulo}${artista ? ` — ${artista}` : ''}${anio ? ` (${anio})` : ''}${sello ? ` · ${sello}` : ''}${pais ? ` · ${pais}` : ''}${genero ? ` · ${genero}${generoSub ? ` / ${generoSub}` : ''}` : ''}`
                : 'Disco identificado'}
            </div>
            <div style={{ fontSize: 10, color: 'rgba(175,169,236,0.6)' }}>
              {camposInciertos.length > 0
                ? 'Campos en naranja requieren revisión · El resto fue rellenado con alta confianza'
                : 'Todos los campos detectados con alta confianza'}
            </div>
            {iaScanNote ? (
              <div style={{ fontSize: 10, color: C.warn, marginTop: 8, lineHeight: 1.45 }}>{iaScanNote}</div>
            ) : null}
          </DCard>
        )}

        {done && !editLoading && !editLoadError && (
          <>
            <TipoPublicacionRow esConjunto={esConjunto} onChangeES={setTipoConjunto} />

            {/* Fotos — máximo 3 por publicación */}
            <div style={{ marginBottom: 6 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>Fotos · máximo 3 por publicación</div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
                {[
                  { label: '★ Portada', sublabel: 'Vinilo · CD · Casete · Blu-ray', index: 0 },
                  { label: 'Cara del disco', sublabel: 'Etiqueta o cara A/B', index: 1 },
                  { label: 'Otros', sublabel: 'Contraportada, extras...', index: 2 },
                ].map(({ label, sublabel, index }) => (
                  <div
                    key={`done-${index}`}
                    style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'stretch', gap: 6, minWidth: 0 }}
                  >
                    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                      <input
                        ref={fotosInputRefs[index]}
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={e => handleFotoSelect(e, index)}
                      />
                      <div
                        role="button"
                        tabIndex={0}
                        onClick={() => fotosInputRefs[index].current?.click()}
                        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && fotosInputRefs[index].current?.click()}
                        style={{
                          width: '100%',
                          aspectRatio: '1',
                          borderRadius: 8,
                          background: fotosPreviews[index] ? 'transparent' : index === 0 ? '#2d1b69' : 'rgba(255,255,255,0.03)',
                          border: fotosPreviews[index]
                            ? `1.5px solid ${index === 0 ? C.gold : 'rgba(255,255,255,0.2)'}`
                            : index === 0
                              ? '1.5px dashed rgba(200,168,75,0.4)'
                              : '1.5px dashed rgba(255,255,255,0.15)',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          minHeight: 70,
                        }}
                      >
                        {fotosPreviews[index] ? (
                          <img src={fotosPreviews[index]} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <span style={{ fontSize: index === 0 ? 22 : 18, color: 'rgba(255,255,255,0.25)' }}>
                            {index === 0 ? '🖼️' : '+'}
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: 9, color: index === 0 ? C.gold : 'rgba(255,255,255,0.35)', textAlign: 'center', lineHeight: 1.3 }}>
                        {label}
                      </div>
                      <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.25)', textAlign: 'center', lineHeight: 1.3 }}>
                        {sublabel}
                      </div>
                    </div>
                    {fotosPreviews[index] ? (
                      <button
                        type="button"
                        disabled={analyzing}
                        onClick={e => handleFotoClear(index, e)}
                        title={analyzing ? 'Espera a que termine el análisis' : 'Quitar esta foto'}
                        style={{
                          alignSelf: 'center',
                          flexShrink: 0,
                          padding: '6px 8px',
                          fontSize: 10,
                          fontWeight: 600,
                          lineHeight: 1.2,
                          borderRadius: 6,
                          border: '1px solid rgba(226, 75, 74, 0.45)',
                          background: analyzing ? 'rgba(255,255,255,0.04)' : 'rgba(226, 75, 74, 0.12)',
                          color: analyzing ? 'rgba(255,255,255,0.25)' : '#E89797',
                          cursor: analyzing ? 'not-allowed' : 'pointer',
                        }}
                      >
                        Quitar
                      </button>
                    ) : null}
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', textAlign: 'center', marginBottom: 8 }}>
                La portada (★) se verifica con IA al publicar · formatos: JPG, PNG, WEBP
              </div>
            </div>

            {/* Disco individual */}
            {!esConjunto && (
              <>
                <FieldInput label="Artista *" value={artista} onChange={e => setArtista(e.target.value)}/>
                <FieldInput label="Título *" value={titulo} onChange={e => setTitulo(e.target.value)}/>
                <FieldInput label="Año" value={anio} onChange={e => setAnio(e.target.value)}/>

                <YesNoRow label="¿Es una edición especial?" value={esEdicionEspecial} onChange={setEdicionEspecialValue} />

                {esEdicionEspecial && (
                  <>
                    <FieldInput
                      label="Nombre de la edición *"
                      value={edicionNombre}
                      onChange={e => setEdicionNombre(e.target.value)}
                      placeholder="Ej: 40th Anniversary Edition, Deluxe..."
                    />
                    <div style={{ width: '50%', marginBottom: 12, minWidth: 140 }}>
                      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Número de catálogo</div>
                      <input
                        value={edicionCatalogo}
                        onChange={e => setEdicionCatalogo(e.target.value)}
                        style={{ ...inpBase, width: '100%' }}
                        onFocus={e => { e.target.style.borderColor = C.gold; }}
                        onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.12)'; }}
                      />
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Qué incluye</div>
                      <input
                        value={edicionContenido}
                        onChange={e => setEdicionContenido(e.target.value)}
                        placeholder="Ej: 2 LPs + libro + poster"
                        style={inpBase}
                        onFocus={e => { e.target.style.borderColor = C.gold; }}
                        onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.12)'; }}
                      />
                    </div>
                    <YesNoRow label="¿Es numerada?" value={edicionNumerada} onChange={v => { setEdicionNumerada(v); if (!v) setEdicionNumeroEjemplar(''); }} />
                    {edicionNumerada && (
                      <FieldInput
                        label="Número de ejemplar"
                        value={edicionNumeroEjemplar}
                        onChange={e => setEdicionNumeroEjemplar(e.target.value)}
                        placeholder="Ej: 1247 / 5000"
                      />
                    )}
                  </>
                )}
              </>
            )}

            {/* Conjunto de discos */}
            {esConjunto && (
              <>
                <FieldInput
                  label="Título del conjunto *"
                  value={conjuntoTitulo}
                  onChange={e => setConjuntoTitulo(e.target.value)}
                />
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Número de discos *</div>
                  <input
                    type="number"
                    min={2}
                    value={conjuntoNumDiscos}
                    onChange={e => {
                      const n = parseInt(e.target.value, 10);
                      if (Number.isNaN(n)) setConjuntoNumDiscos(2);
                      else setConjuntoNumDiscos(Math.max(2, n));
                    }}
                    style={inpBase}
                    onFocus={e => { e.target.style.borderColor = C.gold; }}
                    onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.12)'; }}
                  />
                </div>
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Descripción del conjunto *</div>
                  <textarea
                    value={conjuntoDescripcion}
                    onChange={e => setConjuntoDescripcion(e.target.value)}
                    rows={4}
                    placeholder="Artistas, títulos, estado de cada disco..."
                    style={{ ...inpBase, minHeight: 90, resize: 'vertical' }}
                    onFocus={e => { e.target.style.borderColor = C.gold; }}
                    onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.12)'; }}
                  />
                </div>
                <EstadoBloque value={estado} onChange={setEstado} notaConjunto />
              </>
            )}

            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Sello discográfico</div>
              <input
                value={sello}
                onChange={e => setSello(e.target.value)}
                style={{
                  ...inpBase,
                  border: `0.5px solid ${camposInciertos.some(c => String(c).toLowerCase() === 'sello') ? C.warn : 'rgba(255,255,255,0.12)'}`,
                  background: camposInciertos.some(c => String(c).toLowerCase() === 'sello')
                    ? 'rgba(239,159,39,0.06)'
                    : 'rgba(255,255,255,0.06)',
                }}
                onFocus={e => {
                  e.target.style.borderColor = C.gold;
                }}
                onBlur={e => {
                  e.target.style.borderColor = camposInciertos.some(c => String(c).toLowerCase() === 'sello')
                    ? C.warn
                    : 'rgba(255,255,255,0.12)';
                }}
              />
              {camposInciertos.some(c => String(c).toLowerCase() === 'sello') && (
                <div style={{ fontSize: 10, color: C.warn, marginTop: 3 }}>⚠ Revisa este campo — puede no ser exacto</div>
              )}
            </div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>País de edición</div>
              <input
                value={pais}
                onChange={e => setPais(e.target.value)}
                placeholder="ej: Reino Unido"
                style={{
                  ...inpBase,
                  border: `0.5px solid ${camposInciertos.some(c => String(c).toLowerCase() === 'pais') ? C.warn : 'rgba(255,255,255,0.12)'}`,
                  background: camposInciertos.some(c => String(c).toLowerCase() === 'pais')
                    ? 'rgba(239,159,39,0.06)'
                    : 'rgba(255,255,255,0.06)',
                }}
                onFocus={e => {
                  e.target.style.borderColor = C.gold;
                }}
                onBlur={e => {
                  e.target.style.borderColor = camposInciertos.some(c => String(c).toLowerCase() === 'pais')
                    ? C.warn
                    : 'rgba(255,255,255,0.12)';
                }}
              />
              {camposInciertos.some(c => String(c).toLowerCase() === 'pais') && (
                <div style={{ fontSize: 10, color: C.warn, marginTop: 3 }}>⚠ La IA no pudo detectar este campo</div>
              )}
            </div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Formato *</div>
              <select
                value={formato}
                onChange={e => setFormato(e.target.value)}
                style={inpBase}
                onFocus={e => { e.target.style.borderColor = C.gold; }}
                onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.12)'; }}
              >
                {FORMATO_OPTS.map(f => (
                  <option key={f} value={f} style={{ background: '#1a1d28', color: '#fff' }}>{f}</option>
                ))}
              </select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Género principal *</div>
              <select
                value={genero}
                onChange={e => {
                  setGenero(e.target.value);
                  setGeneroSub('');
                }}
                style={inpBase}
                onFocus={e => {
                  e.target.style.borderColor = C.gold;
                }}
                onBlur={e => {
                  e.target.style.borderColor = 'rgba(255,255,255,0.12)';
                }}
              >
                <option value="" style={{ background: '#1a1d28', color: '#fff' }}>
                  Selecciona categoría…
                </option>
                {GENEROS_PRINCIPALES.map(k => (
                  <option key={k} value={k} style={{ background: '#1a1d28', color: '#fff' }}>
                    {k}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Subgénero (opcional)</div>
              <input
                list="publicar-subgeneros-datalist"
                value={generoSub}
                onChange={e => setGeneroSub(e.target.value)}
                placeholder={genero ? 'Escribe o elige de la lista…' : 'Primero elige un género principal'}
                disabled={!genero}
                style={{
                  ...inpBase,
                  opacity: genero ? 1 : 0.5,
                }}
                onFocus={e => {
                  e.target.style.borderColor = C.gold;
                }}
                onBlur={e => {
                  e.target.style.borderColor = 'rgba(255,255,255,0.12)';
                }}
              />
              <datalist id="publicar-subgeneros-datalist">
                {(GENEROS_TREE[genero] || []).map(s => (
                  <option key={s} value={s} />
                ))}
              </datalist>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)', marginTop: 4, lineHeight: 1.35 }}>
                Sugerencias del catálogo DreamVinyl. Más adelante se podrá ampliar desde base de datos para búsquedas por subgénero en el marketplace.
              </div>
            </div>

            {!esConjunto && <EstadoBloque value={estado} onChange={setEstado} notaConjunto={false} />}

            {/* Ubicación */}
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Ubicación *</div>
              <div style={{ display: 'flex', gap: 8 }}>
                {[`Del perfil${profileLoc.ciudad ? ` — ${profileLoc.ciudad}` : ''}`, 'Personalizada'].map((l, i) => (
                  <button
                    key={l}
                    type="button"
                    onClick={() => setLocSel(i)}
                    style={{
                      flex: 1, padding: '9px', borderRadius: 9, fontSize: 11, cursor: 'pointer',
                      border: `0.5px solid ${locSel === i ? C.gold : 'rgba(255,255,255,0.12)'}`,
                      background: locSel === i ? 'rgba(200,168,75,0.08)' : 'transparent',
                      color: locSel === i ? C.gold : 'rgba(255,255,255,0.5)',
                    }}
                  >{l}</button>
                ))}
              </div>
              {locSel === 1 && (
                <div style={{ marginTop: 12 }}>
                  <UbicacionSelector
                    variant="dark"
                    soloEspana
                    required
                    provincia={pubProvincia}
                    municipio={pubMunicipio}
                    onProvinciaChange={n => {
                      setPubProvincia(n);
                      setPubMunicipio('');
                    }}
                    onMunicipioChange={setPubMunicipio}
                  />
                </div>
              )}
            </div>

            <FieldInput
              label={
                editIsAuction && editAuctionBidCount > 0
                  ? 'Precio (€) — bloqueado (hay pujas)'
                  : 'Precio (€) *'
              }
              type="number"
              value={precio}
              onChange={e => setPrecio(e.target.value)}
              disabled={isEditMode && editIsAuction && editAuctionBidCount > 0}
            />
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 5 }}>Observaciones del vendedor</div>
              <textarea
                value={obs}
                onChange={e => setObs(e.target.value)}
                rows={3}
                placeholder="Describe el estado real, qué incluye, edición especial..."
                style={inpBase}
                onFocus={e => { e.target.style.borderColor = C.gold; }}
                onBlur={e => { e.target.style.borderColor = 'rgba(255,255,255,0.12)'; }}
              />
            </div>

            {/* Opciones de envío */}
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>Opciones de envío *</div>
              {!partnerLogisticsEnabled ? (
                <div
                  style={{
                    fontSize: 11,
                    color: 'rgba(200,168,75,0.85)',
                    marginBottom: 10,
                    lineHeight: 1.45,
                    padding: '8px 10px',
                    borderRadius: 8,
                    background: 'rgba(200,168,75,0.08)',
                    border: '0.5px solid rgba(200,168,75,0.25)',
                  }}
                >
                  En esta fase solo venta simple: entrega en mano o envío que acordéis por chat. La logística con
                  puntos y partners estará disponible en la siguiente fase.
                </div>
              ) : null}
              {visibleShippingOptions.map(({ idx, label, desc }) => (
                <div
                  key={idx}
                  role="button"
                  tabIndex={0}
                  onClick={() => toggleEnvio(idx)}
                  onKeyDown={e => (e.key === 'Enter' || e.key === ' ' ? (e.preventDefault(), toggleEnvio(idx)) : null)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10,
                    border: `0.5px solid ${envios.includes(idx) ? C.gold : 'rgba(255,255,255,0.1)'}`,
                    background: envios.includes(idx) ? 'rgba(200,168,75,0.06)' : 'rgba(255,255,255,0.03)', marginBottom: 8, cursor: 'pointer',
                  }}
                >
                  <div style={{ width: 18, height: 18, borderRadius: 4, border: `1.5px solid ${envios.includes(idx) ? C.gold : 'rgba(255,255,255,0.2)'}`, background: envios.includes(idx) ? C.gold : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    {envios.includes(idx) && <svg width="10" height="10" viewBox="0 0 12 12"><path d="M2 6l3 3 5-5" stroke="#000" strokeWidth="2.5" fill="none"/></svg>}
                  </div>
                  <div>
                    <div style={{ fontSize: 12, color: '#fff', fontWeight: 500 }}>{label}</div>
                    <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', marginTop: 1 }}>{desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <PublicarPartnerCoverage
              showPickup={partnerLogisticsEnabled && envios.includes(1)}
              showStore={partnerLogisticsEnabled && envios.includes(2)}
              modesPickup={modesPickup}
              modesStore={modesStore}
              onModesPickupChange={setModesPickup}
              onModesStoreChange={setModesStore}
              pickupIds={coveragePickupIds}
              storeIds={coverageStoreIds}
              onTogglePickup={toggleCoveragePickup}
              onToggleStore={toggleCoverageStore}
            />

            <div id="publicar-publicacion-feedback" role="status" aria-live="polite" style={{ marginBottom: 12 }}>
              {submitting && (
                <DCard
                  style={{
                    padding: '14px 16px',
                    marginBottom: 10,
                    background: 'rgba(200,168,75,0.1)',
                    borderColor: 'rgba(200,168,75,0.35)',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                    <div
                      style={{
                        width: 22,
                        height: 22,
                        border: '2px solid rgba(200,168,75,0.35)',
                        borderTopColor: C.gold,
                        borderRadius: '50%',
                        animation: 'spin 0.85s linear infinite',
                        flexShrink: 0,
                        marginTop: 2,
                      }}
                    />
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: C.gold, marginBottom: 4 }}>
                        {isEditMode ? 'Guardando cambios…' : 'Enviando el anuncio…'}
                      </div>
                      <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.65)', lineHeight: 1.45 }}>
                        {isEditMode
                          ? 'Estamos actualizando tu anuncio. No cierres esta página hasta que termine.'
                          : 'Estamos guardando la información en DreamVinyl. No cierres esta página hasta que termine.'}
                      </div>
                    </div>
                  </div>
                </DCard>
              )}
              {submitError && !submitting && (
                <DCard
                  style={{
                    padding: '12px 14px',
                    marginBottom: 10,
                    background: 'rgba(226,75,74,0.1)',
                    borderColor: 'rgba(226,75,74,0.35)',
                  }}
                >
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#E24B4A', marginBottom: 4 }}>
                    {isEditMode ? 'No se pudieron guardar los cambios' : 'No se pudo publicar'}
                  </div>
                  <div style={{ fontSize: 12, color: 'rgba(255,200,200,0.95)', lineHeight: 1.45 }}>{submitError}</div>
                  <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.45)', marginTop: 6 }}>
                    Revisa los datos o tu conexión e inténtalo de nuevo.
                  </div>
                </DCard>
              )}
              {submitOk && !submitting && (
                <DCard
                  style={{
                    padding: '14px 16px',
                    marginBottom: 10,
                    background: 'rgba(93,202,165,0.12)',
                    borderColor: 'rgba(93,202,165,0.4)',
                  }}
                >
                  <div style={{ fontSize: 15, fontWeight: 700, color: '#5DCAA5', marginBottom: 6 }}>
                    {isEditMode ? 'Cambios guardados' : 'Publicado correctamente'}
                  </div>
                  <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', lineHeight: 1.45 }}>
                    {isEditMode
                      ? 'Tu anuncio se ha actualizado. En unos segundos volverás a Mis ventas.'
                      : 'Tu anuncio ya está activo en DreamVinyl. En unos segundos volverás al listado.'}
                  </div>
                </DCard>
              )}
            </div>
            <BtnGold
              onClick={handlePublicar}
              disabled={submitting || submitOk}
              style={{
                borderRadius: 14,
                padding: 14,
                fontSize: 15,
                fontWeight: 700,
                marginBottom: 8,
                opacity: submitting || submitOk ? 0.65 : 1,
              }}
            >
              {submitting
                ? 'Enviando…'
                : submitOk
                ? isEditMode
                  ? 'Guardado'
                  : 'Publicado'
                : isEditMode
                ? 'Guardar cambios'
                : 'Publicar anuncio'}
            </BtnGold>
            <BtnGhost>Guardar como borrador</BtnGhost>
          </>
        )}
      </div>
    </div>
  );
}
